import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface Question {
  id: number;
  title?: string;
  description?: string;
  question?: string;
  answer?: boolean;
  publishable_date?: string;
  has_participated?: boolean;
  batch?: {
    id: number;
    name: string;
    media?: string;
  };
  [key: string]: any;
}

interface QuestionState {
  questionsList: Question[];
  setQuestionsList: (newState: Question[]) => void;
}

const useQuestionStore = create<QuestionState>()(
  devtools((set) => ({
    questionsList: [],
    setQuestionsList: (newState) => set(() => ({ questionsList: newState })),
  }))
);

export default useQuestionStore;
